import React, { useEffect, useState } from 'react';
import { track } from '../lib/analytics.js';

export default function Nav({ tweaks }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const linkStyle = { color: 'var(--ink)', textDecoration: 'none', fontSize: 14, fontWeight: 500 };

  return (
    <nav style={{
      position: 'sticky', top: 0, zIndex: 50,
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: scrolled ? '14px 32px' : '22px 32px',
      background: scrolled ? 'rgba(244, 236, 224, 0.78)' : 'transparent',
      backdropFilter: scrolled ? 'blur(16px) saturate(1.2)' : 'none',
      WebkitBackdropFilter: scrolled ? 'blur(16px) saturate(1.2)' : 'none',
      borderBottom: scrolled ? '1px solid var(--ink-12)' : '1px solid transparent',
      transition: 'all 240ms var(--ease)',
    }}>
      <a href="#top" style={{ display: 'flex', alignItems: 'center', gap: 12, textDecoration: 'none', color: 'var(--ink)' }}>
        <img src="/jishu-monogram.svg" width="28" height="28" alt="" />
        <span style={{ fontFamily: 'var(--font-display)', fontStyle: 'italic', fontSize: 22, letterSpacing: '-0.01em' }}>
          Jishu<span style={{ color: 'var(--clay)' }}>·</span>tech
        </span>
      </a>
      <div style={{ display: 'flex', gap: 32, alignItems: 'center' }}>
        <a href="#focus" style={linkStyle}>Focus</a>
        <a href="#research" style={linkStyle}>Research</a>
        <a href="#work" style={linkStyle}>Work</a>
        <a href="#open-source" style={linkStyle}>Open source</a>
        <a href="#writing" style={linkStyle}>Writing</a>
        <a href="#people" style={linkStyle}>People</a>
        <a href="#contact" className="btn btn-primary" style={{ padding: '9px 16px' }} onClick={() => track('cta_click', { where: 'nav' })}>
          Start a project <span style={{ fontFamily: 'var(--font-mono)' }}>→</span>
        </a>
      </div>
    </nav>
  );
}
